import React from 'react';
import SamuraiGame from '../SamuraiGame';

const DepthTransitions = () => {
    return <SamuraiGame initialDrillIndex={6} />;
};

export default DepthTransitions;
